import { MDS_COLORS_BACKGROUND_INVERSE } from '@rappi/mustache-b2b-foundations';
import styled from 'styled-components';
export const Container = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
`;
export const TabsContainer = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
`;
export const TabContent = styled.div `
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  padding: 24px;
  border-radius: 8px;
  background-color: ${MDS_COLORS_BACKGROUND_INVERSE};
`;
